import {
  GENERAL_CONTRACTOR_TEAM_USERS_ADD,
  GENERAL_CONTRACTOR_TEAM_USERS_EDIT,
  GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS,
  GENERAL_CONTRACTOR_TEAM_USERS_REMOVE,
  GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS,
} from 'actions/admin/team/action-types';
import { sortByAttribute } from 'services/utils/sort-util';

export const initialState = {
  roles: [],
  users: [],
};

export default function generalContractorTeamDataReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case GENERAL_CONTRACTOR_TEAM_ROLES_LOAD_SUCCESS:
      return {
        ...state,
        roles: action.payload,
      };

    case GENERAL_CONTRACTOR_TEAM_USERS_ADD:
      return {
        ...state,
        users: sortByAttribute(
          state.users.concat([action.payload]),
          'first_name'
        ),
      };

    case GENERAL_CONTRACTOR_TEAM_USERS_EDIT:
      return {
        ...state,
        users: state.users.map((user) => {
          if (user.id === action.payload.id) {
            return action.payload;
          } else {
            return user;
          }
        }),
      };

    case GENERAL_CONTRACTOR_TEAM_USERS_LOAD_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };

    case GENERAL_CONTRACTOR_TEAM_USERS_REMOVE:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
      };

    default:
      return state;
  }
}
